module.exports = __webpack_public_path__ + "media/images/lb/059-67cc675825ee8c94932cc39f8c174acc.svg";